import React from 'react';

export default function TenantChooserPage() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Tenant chooser shell (Phase 1C).</p>
    </main>
  );
}
